import React from "react";
import UserTable from "./components/Table/UserTable";

const Users = () => {
    return (
        <div>
            <UserTable />
        </div>
    );
};

export default Users;
